"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogLevels;
(function (LogLevels) {
    LogLevels["DEBUG"] = "debug";
    LogLevels["INFO"] = "info";
    LogLevels["WARN"] = "warn";
    LogLevels["ERROR"] = "error";
    LogLevels["FATAL"] = "fatal";
})(LogLevels = exports.LogLevels || (exports.LogLevels = {}));
//# sourceMappingURL=log-levels.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuejs-logger/dist/vue-logger/enum/log-levels.js
// module id = nyL1
// module chunks = 101